import Vue from 'vue'
import Vuex from 'vuex'
import { slides } from '../content/slider'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    startScreenLeft: false,
    slideNumber: 0,
    showGallery: false,
    slidesArray: [{id: 1, infoBlockLeft: false}, //певры блок это стартовый экран с логотипом
             {id: 2, infoBlockLeft: true}, //второй блок это просто картинка сразу, поэтому в мутациях смотрим, что слайд с id = 2 всегда инфоблокЛефт true
             {id: 3, infoBlockLeft: false},
             {id: 4, infoBlockLeft: false},
             {id: 5, infoBlockLeft: false},
             {id: 6, infoBlockLeft: false},
             {id: 7, infoBlockLeft: false}],
    windowWidth: null,
    videoPopupOpened: false,
    wentToGalleryFromSlider: false
  },
  mutations: {
    setWindowWidth(state, payload) {
      state.windowWidth = payload
    },
    nextSlide (state) {
      if (state.slideNumber <= slides.length && (state.slidesArray[state.slideNumber].infoBlockLeft || state.slideNumber === 0)) {
        
        state.slideNumber++
        return
      }
      if (state.slideNumber <= slides.length && state.startScreenLeft && state.slideNumber !== 1) {
        state.slidesArray[state.slideNumber].infoBlockLeft = !state.slidesArray[state.slideNumber].infoBlockLeft
      }
    },
    prevSlide(state) {
      if (state.slideNumber > 0 && (state.slideNumber !== slides.length || !state.slidesArray[slides.length].infoBlockLeft)) {
        state.slideNumber--
      } 
      state.slidesArray.forEach((slide) => {slide.infoBlockLeft = slide.id === 2})
    },
    toggleStartScreen(state, payload) {
      state.startScreenLeft = payload;
    },
    toggleGallery(state) {
      state.showGallery = !state.showGallery
    },
    openVideoPopup(state) {
      state.videoPopupOpened = true
    },
    closeVideoPopup(state) {
      state.videoPopupOpened = false
    },
    setGalleryEntranceFromSlider(state) {
      state.wentToGalleryFromSlider = !state.wentToGalleryFromSlider
    }
  }
})